import { useState, useEffect, useCallback } from "react"
import API from "../config/api"

const memoryCache = new Map()

const useFetch = (url, options = {}) => {
  const { skip = false, cache = false } = options
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(!skip)
  const [error, setError] = useState(null)

  const fetchData = useCallback(
    (force = false) => {
      // use cache only if not forced
      if (!force && cache && memoryCache.has(url)) {
        setData(memoryCache.get(url))
        setLoading(false)
        return
      }

      setLoading(true)
      setError(null)

      fetch(`${API}${url}`)
        .then((res) => res.json())
        .then((result) => {
          setData(result)

          if (cache) {
            memoryCache.set(url, result)
          }
        })
        .catch(setError)
        .finally(() => setLoading(false))
    },
    [url, cache]
  )

  // refetch = invalidate + force fetch
  const refetch = useCallback(() => {
    memoryCache.delete(url)
    fetchData(true)
  }, [url, fetchData])

  useEffect(() => {
    if (!skip) {
      fetchData()
    }
  }, [fetchData, skip])

  return { data, loading, error, refetch }
}

export default useFetch
